/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { WorkingModeApplyLeafSpec } from './workingModeApplyLeafSpec';

/**
 * Parameters for working-mode apply background job.
 */
export interface WorkingModeApplyJobParams {
  moduleId: string;
  version: string;
  leaves?: WorkingModeApplyLeafSpec[];
}
